// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"74815a1d","419":"315e165f","458":"4543f802","748":"9131fd57","774":"cd9b98ba","787":"1e83dcc9","858":"2315ea04","885":"8b00ee5e"}[chunkId] + ".chunk.js";
};